import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ReactCountryFlag from 'react-country-flag';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SiteActions from "redux/actions/site";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  label: {
    color: '#b6b8bc',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0.56,
  },
  flag: {
    marginRight: 2,
    fontSize: '26px !important',
    verticalAlign: "middle",
    marginTop: -2,
  },
  icon: {
    color: '#b6b8bc',
  },
  select: {
    backgroundColor: 'transparent !important',
    marginTop: 4
  }
}));


/*
List of codes: https://tnovau.github.io/react-circle-flags/gallery
*/
const ccyFlagCodeMap = [
  { ccy: "GBP", code: "GB" },
  { ccy: "USD", code: "US" },
  { ccy: "EUR", code: "EU" },
  { ccy: "JPY", code: "JP" },
  { ccy: "NZD", code: "NZ" }
];


function CurrencyMenu({ ccy, ccyAPI, SiteActions: { setCCY, setCCYAPI }, currencies = [], defaultCurrency = '', disabled, isApiPage=false, style={} }) {
  const classes = useStyles();

  const showCurrencies = currencies.length === 0 ? [defaultCurrency] : currencies;

  const currency = isApiPage ? ccyAPI : ccy;

  const [selectedCCY, setSelectedCCY] = React.useState(false);

  React.useEffect(() => {
    let startingCurrency = showCurrencies.includes(currency) ? currency : false;

    if (!startingCurrency) {
      startingCurrency = showCurrencies.length > 0 ? showCurrencies[0] : [];
      if (currency !== startingCurrency) {
        if(isApiPage){
          setCCYAPI(startingCurrency);
        }else{
          setCCY(startingCurrency);
        }
      }
    }

    setSelectedCCY(startingCurrency);

  }, [currency, currencies]);

  

  const handleChange = (event) => {
    
    if(isApiPage){
      setCCYAPI(event.target.value);
    }else{
      setCCY(event.target.value);
    }
    setSelectedCCY(event.target.value)
  };

  return (
    <div style={style}>
      <Select
        disabled={showCurrencies.length < 2 || disabled}
        classes={{ icon: classes.icon, select: classes.select }}
        disableUnderline
        variant="standard"
        value={selectedCCY}
        onChange={handleChange}
      >
        {ccyFlagCodeMap.filter(c => showCurrencies.includes(c.ccy)).map((option) => (
          <MenuItem value={option.ccy}>
            <ReactCountryFlag className={classes.flag} countryCode={option.code.toUpperCase()} />
            <span className={classes.label}>{option.ccy}</span>
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

export default connect(
  (state) => ({
    authUser: state.auth.user,
    ccy: state.site.ccy,
    ccyAPI: state.site.ccyAPI,
  }),
  (dispatch) => ({
    SiteActions: bindActionCreators({ ...SiteActions }, dispatch)
  })
)(CurrencyMenu);